import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ShieldCheckIcon,
    ArrowRightIcon,
    BuildingOffice2Icon,
    CheckIcon
} from '@heroicons/react/24/outline';

export default function RegisterType() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#f6f6f6] flex flex-col justify-between p-4 sm:p-6 md:p-10 relative overflow-hidden font-sans">

            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[300px] bg-gradient-to-b from-[#adc6ce]/20 to-transparent blur-[120px] pointer-events-none" />





            <div className="max-w-5xl w-full mx-auto my-auto py-12 z-10">
                <div className="text-center mb-12 sm:mb-16">
                    <span className="text-xs font-bold tracking-[0.25em] text-[#155e75] uppercase block mb-3">
                        Onboarding Portal
                    </span>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
                        Select Your Portal Identity
                    </h1>
                    <p className="text-sm sm:text-base text-slate-600 max-w-xl mx-auto leading-relaxed">
                        To initialize access to the central domain registration, please select the account classification that matches your organizational role.
                    </p>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">

                    <div
                        onClick={() => navigate('/register?type=PRODUCER')}
                        className="group relative bg-white border border-[#adc6ce]/60 rounded-2xl p-6 sm:p-8 lg:p-10 hover:border-[#155e75] hover:bg-white transition-all duration-300 cursor-pointer flex flex-col justify-between shadow-sm hover:shadow-xl hover:shadow-[#155e75]/5"
                    >
                        <div>
                            <div className="flex justify-between items-start mb-6">
                                <div className="w-12 h-12 rounded-xl bg-[#155e75]/5 border border-[#155e75]/10 flex items-center justify-center text-[#155e75] group-hover:bg-[#155e75] group-hover:text-white transition-all duration-300">
                                    <BuildingOffice2Icon className="w-6 h-6" />
                                </div>
                                <span className="text-[10px] font-bold text-[#155e75] bg-[#155e75]/10 px-2.5 py-1 rounded-full uppercase tracking-wider">
                                    Market Participant
                                </span>
                            </div>

                            <h2 className="text-2xl font-bold text-slate-900 mb-3 tracking-tight">
                                Producer / Trader
                            </h2>
                            <p className="text-sm text-slate-600 mb-6 leading-relaxed">
                                For entities managing renewable energy assets, executing certificate transfers, and participating in registry trade operations.
                            </p>

                            <hr className="border-[#adc6ce]/30 my-6" />

                            <ul className="space-y-3.5 text-xs text-slate-700 mb-8 font-semibold">
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>Asset and Production Device Registration</span>
                                </li>
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>EECS Certificate Portfolio Management</span>
                                </li>
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>Inter-Registry Export & Import Trading</span>
                                </li>
                            </ul>
                        </div>

                        <button className="w-full py-3.5 px-4 bg-[#f6f6f6] hover:bg-[#155e75] border border-[#adc6ce]/50 hover:border-[#155e75] text-[#155e75] hover:text-white text-xs font-bold rounded-xl tracking-wider uppercase transition-all duration-300 flex items-center justify-center gap-2 shadow-sm group-hover:shadow-lg group-hover:shadow-[#155e75]/10">
                            Initialize KYC Registration
                            <ArrowRightIcon className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                        </button>
                    </div>


                    <div
                        onClick={() => navigate('/register?type=VVB_AUDITOR')}
                        className="group relative bg-white border border-[#adc6ce]/60 rounded-2xl p-6 sm:p-8 lg:p-10 hover:border-[#155e75] hover:bg-white transition-all duration-300 cursor-pointer flex flex-col justify-between shadow-sm hover:shadow-xl hover:shadow-[#155e75]/5"
                    >
                        <div>
                            <div className="flex justify-between items-start mb-6">
                                <div className="w-12 h-12 rounded-xl bg-[#6a99a7]/10 border border-[#6a99a7]/20 flex items-center justify-center text-[#155e75] group-hover:bg-[#155e75] group-hover:text-white transition-all duration-300">
                                    <ShieldCheckIcon className="w-6 h-6" />
                                </div>
                                <span className="text-[10px] font-bold text-slate-700 bg-slate-100 px-2.5 py-1 rounded-full uppercase tracking-wider">
                                    Compliance Body
                                </span>
                            </div>

                            <h2 className="text-2xl font-bold text-slate-900 mb-3 tracking-tight">
                                Independent Auditor (VVB)
                            </h2>
                            <p className="text-sm text-slate-600 mb-6 leading-relaxed">
                                For accredited verification bodies responsible for auditing plant data, verifying device emissions, and approving regulatory compliance.
                            </p>

                            <hr className="border-[#adc6ce]/30 my-6" />

                            <ul className="space-y-3.5 text-xs text-slate-700 mb-8 font-semibold">
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>Dedicated Auditor Validation Node Access</span>
                                </li>
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>Regulatory Compliance Verification</span>
                                </li>
                                <li className="flex items-center gap-3">
                                    <CheckIcon className="w-4 h-4 text-[#155e75] flex-shrink-0" />
                                    <span>Device Meter Readings Validation</span>
                                </li>
                            </ul>
                        </div>

                        <button className="w-full py-3.5 px-4 bg-[#f6f6f6] hover:bg-[#155e75] border border-[#adc6ce]/50 hover:border-[#155e75] text-[#155e75] hover:text-white text-xs font-bold rounded-xl tracking-wider uppercase transition-all duration-300 flex items-center justify-center gap-2 shadow-sm group-hover:shadow-lg group-hover:shadow-[#155e75]/10">
                            Request Accreditation
                            <ArrowRightIcon className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                        </button>
                    </div>
                </div>
            </div>


            <div className="w-full max-w-5xl mx-auto text-center pt-8 border-t border-slate-200 z-10">
                <p className="text-[10px] text-[#6a99a7] font-bold tracking-widest uppercase">
                    Sovereign Registry Protocol • Kingdom of Morocco
                </p>
            </div>
        </div>
    );
}